module.exports = __webpack_public_path__ + "static/img/14.8305dc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/14.png
// module id = so/f
// module chunks = 1